module.exports = __webpack_public_path__ + "img/享生活.25f6dc94.png";